<template>
  <div 
    :style="{background: backgroundColor}"
    @click="getCellNumber" 
    :class="[{'table-column_full-width': cellFullWidth},'table-column',{'table-column_border': cellBorder},]">
    <slot v-bind:tough="true"></slot>
  </div>
</template>

<script>
export default {
  name: "BaseTableCol",
  props: {
    cellBorder: {
      type: Boolean,
      required: false
    },
    backgroundColor: {
      type: String,
      required: false
    },
    cellFullWidth: {
      type: Boolean,
      required: false
    },
    element: {
      type: [Object,String,Number],
      required: false
    },
  },
    methods: {
    getCellNumber() {
      this.$emit('getCellNumber')
    }
  }
}
</script>

<style lang="scss" scoped>
.table-column {
  padding: 15px 0;
  position: relative;
  &_full-width {
    width: 100%;
    text-align: center;
  }
}

.card {
  background-color: dodgerblue;
  color: white;
  padding: 1rem;
  height: 4rem;
}

.cards {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-gap: 1rem;
}

.content-left {
  justify-content: flex-start;
}

</style>
